/**
 * Returns string value for the `tier` parameter.
 */
export const getUserTierForSapi = ({isMemberPlus, isAuthenticated}) => {
  const tier = isAuthenticated ? 'member' : ''
  return isMemberPlus ? 'plus' : tier
}
